module.exports = __webpack_public_path__ + "img/bwlogo.fd690b56.svg";